import { render, staticRenderFns } from "./Rx.vue?vue&type=template&id=fae37980"
import script from "./Rx.vue?vue&type=script&lang=js"
export * from "./Rx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports